export default __webpack_public_path__ + "f228705c2d4306bdbe3bf568ead09564.svg";